import styled, { css } from 'styled-components';
import { Anchor, Menu, Popover, TextButton, token } from '@zillow/constellation';

/**
 * TODO: refactor to use constellation values
 * currently the MUI breakpoint is being used in this module
 */
import { MUIBreakpointLg } from '../../constants';

export const menuMaxHeight = 350;

const getPopoverArrowStyles = ({ isLayoutHorizontal = false }: { isLayoutHorizontal: boolean }) => {
  if (isLayoutHorizontal) {
    return css`
      /* hide child: PopoverArrow */
      && [class^='PopoverArrow'] {
        display: none;
      }
    `;
  }
};

const NoTextDecorationMixin = () => {
  return css`
    text-decoration: none;

    &&:hover {
      text-decoration: none;
    }
  `;
};

export const StyledIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  /* did not use a styled component as this is a dynamic component name */
  .IconChevron {
    /* add offset to align to the bottom and account for edge cases  */
    position: relative;
    top: 2px;
  }

  &&:hover {
    cursor: pointer;
  }
`;

export const StyledPopover = styled(Popover)<{ isLayoutHorizontal: boolean }>`
  display: none;

  /* hide child: PopoverArrow */
  /* && [class^='PopoverArrow'] {
    display: none;
  } */

  ${getPopoverArrowStyles}

  @media screen and (min-width: ${MUIBreakpointLg}) {
    display: block;

    && [class^='DialogBody'] {
      padding-left: 0;
      padding-right: 0;
      overflow: hidden;
    }
  }
`;

export const StyledMenu = styled(Menu)`
  max-height: ${menuMaxHeight}px;
  overflow-y: scroll;

  && {
    margin-top: 5px;
  }
`;

export const StyledAnchorWithIcon = styled(Anchor)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  ${NoTextDecorationMixin}
`;

export const StyledAnchor = styled(Anchor)`
  width: 100%;

  ${NoTextDecorationMixin}
`;

export const StyledNoTextDecorationTextButton = styled(TextButton)`
  color: ${token('colors.brand')};
  ${NoTextDecorationMixin}
`;

export const StyledCloseButton = styled.div`
  display: none;
`;
